import { render, staticRenderFns } from "./BookingsReport.vue?vue&type=template&id=fc42b076&scoped=true"
import script from "./BookingsReport.vue?vue&type=script&lang=js"
export * from "./BookingsReport.vue?vue&type=script&lang=js"
import style0 from "./BookingsReport.vue?vue&type=style&index=0&id=fc42b076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc42b076",
  null
  
)

export default component.exports